if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const url = opener.getAttribute('data-product-url');
        //add argument for is_quickview=true
        const quickViewUrl = new URL(url, window.location.origin);
        quickViewUrl.searchParams.set('is_quickview', 'true');

        fetch(quickViewUrl.toString())
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            if (productElement.querySelector('sticky-atc')) {
              productElement.querySelector('sticky-atc').remove();
            }

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;

        // Vérifier si des éléments product-recommendations existent
        const productRecommendations = productElement.querySelectorAll('product-recommendations');

        if (productRecommendations.length > 0) {
          // Approche alternative : extraire les product-recommendations avant modification
          const recommendationsData = [];

          // Sauvegarder les informations sur chaque élément product-recommendations
          productRecommendations.forEach((element) => {
            // Créer un marqueur unique pour retrouver la position
            const marker = `recommendation-position-${Math.random().toString(36).substring(2, 10)}`;
            const parent = element.parentNode;

            // Stocker les données nécessaires pour restaurer l'élément
            recommendationsData.push({
              html: element.outerHTML,
              marker: marker,
              parent: parent,
            });

            // Remplacer l'élément par un span avec le marqueur
            const markerSpan = document.createElement('span');
            markerSpan.setAttribute('data-recommendation-marker', marker);
            parent.replaceChild(markerSpan, element);
          });

          // Remplacer les IDs dans le reste du contenu
          productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);

          // Restaurer les éléments product-recommendations à leur position d'origine
          recommendationsData.forEach((data) => {
            const markerElement = productElement.querySelector(`[data-recommendation-marker="${data.marker}"]`);
            if (markerElement) {
              // Créer un conteneur temporaire pour parser le HTML original
              const temp = document.createElement('div');
              temp.innerHTML = data.html;
              const originalElement = temp.firstChild;

              // Remplacer le marqueur par l'élément original
              markerElement.parentNode.replaceChild(originalElement, markerElement);
            }
          });
        } else {
          // Si pas de product-recommendations, faire le remplacement simple
          productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        }

        // Mise à jour des attributs de l'élément parent
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    },
  );
}
